import { FunctionComponent } from "react";
import AsyncSearchSelect from "../common/async_search_select/AsyncSearchSelect";
import { fetchGet, toQueryString } from "../../../service/api_client";
import { ItemModelV2 } from "../../../erp/inventory/models/item_model";
import { MasterItemStatus } from "../../../utils/enums";

interface ItemSelectFieldProps {
  value?: ItemModelV2 | null;
  onSelect: (item: ItemModelV2) => void;
  disabled?: boolean;
  placeholder?: string;
}

const fetchItems = async (query: string): Promise<ItemModelV2[]> => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/items`;
  const res = await fetchGet(
    url +
      toQueryString({
        item_name: query,
        item_code: query,
        mpn: query,
        page: 1,
        count: 20,
        all: true,
        status: MasterItemStatus.Approved,
      }),
  );
  return res.success ? (res.data?.data ?? []) : [];
};

/** Approved-item async search. Reusable wherever an item picker is needed. */
const ItemSelectField: FunctionComponent<ItemSelectFieldProps> = ({
  value,
  onSelect,
  disabled,
  placeholder,
}) => (
  <AsyncSearchSelect<ItemModelV2>
    value={value ?? null}
    onSelect={onSelect}
    disabled={disabled}
    size="md"
    placeholder={placeholder ?? "Search item by name, code or MPN"}
    fetcher={fetchItems}
    getOptionLabel={(i) => i?.name ?? ""}
    getOptionKey={(i) => i?.id ?? i?.item_code ?? ""}
    renderOption={(i) => (
      <div className="text-xs">
        <b>{i.name}</b>
        {i.mpn ? ` - ${i.mpn}` : ""}
        {i.description ? (
          <span className="text-gray-500 italic"> - {i.description}</span>
        ) : null}
      </div>
    )}
  />
);

export default ItemSelectField;
